import React from 'react'

import useTriggerStore from "../../../stores/TriggersStore"
import  useUserStore  from '../../../stores/UserStore'
import Trigger from './Trigger'

function TriggerStates() {
    const triggers = useTriggerStore((state) => state.triggers)
    const userID = useUserStore((state) => state.userID)
    
  return (
    <div className="mobile_state_container">
        {triggers && Object.keys(triggers).length !== 0  ? Object.keys(triggers).map(function(exchange) {
            return (
                <div className="mobile_state_exchange_container" key={exchange}> 
                    <h3 className="states_exchange_title">{exchange.replaceAll(userID+'@', '')}</h3> 
                    <ul className="states_ul">
                        {Object.keys(triggers[exchange]).map((instrument) =>
                            Object.keys(triggers[exchange][instrument]).map((side) =>
                            Object.keys(triggers[exchange][instrument][side]).map(
                            (trigger_id) => {
                                const trigger_unit =
                                triggers[exchange][instrument][side][trigger_id];
                                return (
                                <>
                                    <>
                                        {trigger_unit && trigger_unit.infos ? <Trigger key={trigger_id} infos={trigger_unit.infos} /> : null}
                                        </>
                                </>
                                );
                            }
                            )
                        )
                        )}
                    </ul>
                </div>
            )
        }) : null}
    </div>
  )
}

export default TriggerStates